
import { defineComponent } from "vue";

const MINUTES_PER_HOUR = 60;
const MIN_LOCK_MINUTES = 1;

export default defineComponent({
  name: "ModalBlockLogin",

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    lockDurationMinutes: {
      type: Number,
      default: 1,
    },
  },

  emits: ["update:modelValue"],

  computed: {
    isShow: {
      get(): boolean {
        return this.modelValue;
      },
      set(value: boolean) {
        this.$emit("update:modelValue", value);
      },
    },
    descriptionText(): string {
      const duration = this.FormatLockDuration(this.lockDurationMinutes);
      const line1 = "Your account is temporarily suspended after several failed password attempts.";
      const line2 = `Please try again in ${duration}.`;
      return `${line1}\n${line2}`;
    },
  },

  methods: {
    FormatLockDuration(totalMinutes: number): string {
      const safeTotalMinutes = Math.max(totalMinutes, MIN_LOCK_MINUTES);
      if (safeTotalMinutes < MINUTES_PER_HOUR) {
        return `${safeTotalMinutes} ${safeTotalMinutes === 1 ? "minute" : "minutes"}`;
      }
      const hours = Math.floor(safeTotalMinutes / MINUTES_PER_HOUR);
      const minutes = safeTotalMinutes % MINUTES_PER_HOUR;
      if (minutes === 0) {
        return `${hours} ${hours === 1 ? "hour" : "hours"}`;
      }
      return `${hours} ${hours === 1 ? "hour" : "hours"} ${minutes} ${minutes === 1 ? "minute" : "minutes"}`;
    },
    HandleConfirm() {
      this.$emit("update:modelValue", false);
    },
  },
});
